import { t } from "../../../i18n";
import { fmt } from "@tasduvar/engine";
import type { ReportModel } from "../model";
import { Section } from "./common";

export function ProjectInfo({ m }: { m: ReportModel }): JSX.Element {
  const i = m.project.info;
  return (
    <Section id="projectInfo" title={t("1. Proje ve Duvar Bilgileri")}>
      <table>
        <tbody>
          <tr><th style={{ width: "30%" }}>{t("Proje adı")}</th><td>{i.name}</td></tr>
          <tr><th>{t("İl / İlçe")}</th><td>{[i.city, i.district].filter(Boolean).join(" / ") || "—"}</td></tr>
          <tr><th>{t("Ada / Parsel")}</th><td>{i.block ?? "—"} / {i.parcel ?? "—"}</td></tr>
          {i.location ? <tr><th>{t("Koordinat (enlem, boylam)")}</th><td className="num">{i.location.lat.toFixed(6).replace(".", ",")}° · {i.location.lon.toFixed(6).replace(".", ",")}°</td></tr> : null}
          <tr><th>{t("İşveren")}</th><td>{i.owner ?? "—"}</td></tr>
          <tr><th>{t("Proje müellifi")}</th><td>{i.engineer?.name ?? "—"}{i.engineer?.chamberNo ? ` (Oda sicil no ${i.engineer.chamberNo})` : ""}</td></tr>
          <tr><th>{t("Tarih / Revizyon")}</th><td>{i.date} / {i.revision}</td></tr>
          {i.notes ? <tr><th>{t("Notlar")}</th><td>{i.notes}</td></tr> : null}
        </tbody>
      </table>
      <h3>{t("Duvarlar")}</h3>
      <table>
        <thead><tr><th>{t("Duvar")}</th><th className="num">H (m)</th><th className="num">B (m)</th><th className="num">{t("Df (m)")}</th><th>{t("Deprem")}</th><th>{t("Sonuç")}</th></tr></thead>
        <tbody>
          {m.walls.map(({ wall, result, error }) => (
            <tr key={wall.id}>
              <td>{wall.name}</td>
              <td className="num">{result ? fmt(result.geometry.yTop) : "—"}</td>
              <td className="num">{result ? fmt(result.geometry.B) : "—"}</td>
              <td className="num">{fmt(wall.geometry.embedmentDepth)}</td>
              <td>{wall.seismic.enabled ? `Evet (${wall.seismic.level})` : t("Hayır")}</td>
              <td>{error ? <span className="bad">{t("Hesap yapılamadı")}</span> : result?.ok ? <span className="ok">{t("SAĞLIYOR")}</span> : <span className="bad">{t("SAĞLAMIYOR")}</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Section>
  );
}
